export class Address {
  public City: string;

  public Country: string;

  public State: string;

  public Street1: string;

  public Street2: string;

  public Unit: string;

  public Zip: string;
}
